import { useState, useEffect } from 'react';

/**
 * Como useState pero persistido en sessionStorage: el valor sobrevive a un
 * refresh de la página y se limpia al cerrar la pestaña. Pensado para estado
 * de sesión no crítico (filtros, mes seleccionado, TRM, etc.).
 */
export const useSessionState = (key, initialValue) => {
  const [value, setValue] = useState(() => {
    try {
      const raw = sessionStorage.getItem(key);
      return raw !== null ? JSON.parse(raw) : initialValue;
    } catch {
      // sessionStorage no disponible o JSON corrupto: usamos el valor inicial.
      return initialValue;
    }
  });

  useEffect(() => {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch {
      // Cuota excedida: mantenemos el valor solo en memoria.
    }
  }, [key, value]);

  return [value, setValue];
};
